import { atomWithReset } from 'jotai/utils';

type FilterType = 'search' | 'advanced' | null;

export const activeFilterTypeState = atomWithReset<FilterType>(null);
